import { set } from 'cerebral/operators';
import { state, props } from 'cerebral/tags';

export default [
    set(state`app.notification`, props`notification`),
];



// WEBPACK FOOTER //
// ./src/store/modules/app/signals/setNotification.js